import styled from 'styled-components';
import IconArrowDownCircleOutline from './IconArrowDownCircleOutline';
var IconArrowRightCircleOutline = /*#__PURE__*/styled(IconArrowDownCircleOutline).withConfig({
  displayName: "IconArrowRightCircleOutline",
  componentId: "c11n-8-111-1__sc-8q6lgo-0"
})(["transform:rotate(270deg);"]);
export default IconArrowRightCircleOutline;